module.exports = __webpack_public_path__ + "static/media/scroll-sign.8815e4a9.png";